import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Text,
  TableCell,
} from "grommet";

export class IncidentsView extends Component {
  state = {
    tableRows: [],
  };

  updateRowData = async () => {
    let tableRows = [];
    let tableRowElement;

    const shiftGuards = this.props.shiftData.Shift_Gaurds;

    console.log(this.props);

    if (typeof shiftGuards === "object") {
      const firebase = this.props.firebase;
      for (const shiftGuard of shiftGuards) {
        //shiftGuards.forEach(shiftGuard => {
        if (typeof shiftGuard.Incidents === "object") {
          for (const incident of shiftGuard.Incidents) {
            //shiftGuard.Incidents.forEach(incident => {
            let description;
            if (typeof incident.Description === "string") {
              description = incident.Description;
            } else {
              description = "n/a";
            }
            let url;
            if (
              typeof incident.ImageUrl === "string" &&
              incident.ImageUrl !== "none"
            ) {
              const images = firebase.storage().ref().child("photos/");
              const image = images.child(incident.Id + ".jpg");
              url = await image
                .getDownloadURL()
                .then(async (url) => {
                  return url;
                })
                .catch(async (err) => {
                  return "n/a";
                });
              //url = incident.ImageUrl;
            } else {
              url = "n/a";
            }

            const timeTaken =
              (new Date(incident.EndDateTime) -
                new Date(incident.StartDateTime)) /
              1000;
            const time = this.getStringFromSeconds(timeTaken);
            const startTime = this.getPrettyDateString(incident.StartDateTime);
            const endTime = this.getPrettyDateString(incident.EndDateTime);
            tableRowElement = {
              title: incident.Title,
              description: incident.Description,
              guardName: shiftGuard.Gaurd.GaurdFirstName,
              startTime: startTime,
              endTime: endTime,
              timeTaken: time,
              url: url,
            };
            tableRows.push(tableRowElement);
          }
        }
      }
    }

    const newState = {
      ...this.state,
      tableRows: tableRows,
    };
    this.setState(newState);
  };

  componentWillMount = () => {
    this.updateRowData();
  };

  getStringFromSeconds = (timeTaken) => {
    const hours = Math.floor(timeTaken / 3600);
    timeTaken %= 3600;
    const minutes = Math.floor(timeTaken / 60);
    const seconds = timeTaken % 60;

    let minuteString;
    let secondString;
    let hoursString;

    if (hours < 10) {
      hoursString = "0" + hours;
    } else {
      hoursString = "" + hours;
    }

    if (minutes < 10) {
      minuteString = "0" + minutes;
    } else {
      minuteString = "" + minutes;
    }

    if (seconds < 10) {
      secondString = "0" + seconds;
    } else {
      secondString = "" + seconds;
    }
    const secondStringArray = secondString.split(".");

    const timeString =
      hoursString + ":" + minuteString + ":" + secondStringArray[0];
    return timeString;
  };

  getPrettyDateString = (dateString) => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    const thirdArray = secondArray[0].split(".");
    return thirdArray[0];
  };

  render() {
    const tableRows = this.state.tableRows;
    return (
      <Box>
        <Table>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                <Text> Guard Name </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text>Title </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text>Description </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text> Start Time </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text> End Time </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text> Total Time </Text>
              </TableCell>
              <TableCell scope="col" border="bottom">
                <Text> Photo </Text>
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tableRows.map((tableRow, index) => {
              let imageView;
              if (tableRow.url === "n/a") {
                imageView = <Text>n/a</Text>;
              } else {
                imageView = (
                  <Box >
                    <img
                      height="150px"
                      width="150px"
                      object-fit="cover"
                      src={tableRow.url}
                    />
                  </Box>
                );
              }
              return (
                <TableRow key={index}>
                  <TableCell scope="row">
                    <Text>{tableRow.guardName}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.title}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.description}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.startTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.endTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.timeTaken}</Text>
                  </TableCell>
                  <TableCell>{imageView}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default IncidentsView;
